<template>
  <div class="block">
    <el-tag>选择账户： </el-tag>
    <div class="block">
      <el-cascader
        v-model="userUalue"
        :options="options1"
        filterable></el-cascader>
    </div>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择汇总方式：</el-tag>

    <el-select v-model="value" placeholder="请选择">
      <el-option
        v-for="item in options"
        :key="item.value"
        :label="item.label"
        :value="item.value">
      </el-option>
    </el-select>
    <el-divider direction="vertical"></el-divider>
    <el-tag>选择层级：</el-tag>
    <el-select v-model="values" placeholder="请选择">
      <el-option
        v-for="items in level"
        :key="items.value"
        :label="items.label"
        :value="items.value">
      </el-option>
    </el-select>

    <el-divider direction="vertical"></el-divider>
    <el-tag>输入起止日期：</el-tag>

    <el-date-picker
      v-model="value1"
      type="daterange"
      align="right"
      unlink-panels
      range-separator="至"
      start-placeholder="开始日期"
      end-placeholder="结束日期"
      value-format="yyyyMMdd"
      :picker-options="pickerOptions"
      @change="chooseTimeRange">
    </el-date-picker>
    <el-button type="primary" v-on:click="exportExcel" round>导出</el-button>
    <el-button type="primary" v-on:click="getDataList" :disabled="isDisable" round>查询</el-button>
    <el-divider></el-divider>

    <el-table
      v-loading="loading"
      element-loading-text="拼命查询中..."
      stripe
      :default-sort = "{prop: 'date', order: 'descending'}"
      :data="datas"
      id="exportTab"
      :summary-method="getSummaries"
      show-summary
      style="width: 100%">
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        fixed
        prop="campaignName"
        label="计划名称"
        width="180">
      </el-table-column>

      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupId"
        label="广告组ID"
        width="100">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="groupName"
        label="广告组名称"
        width="200">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementId"
        width="120"
        label="广告ID">
      </el-table-column>
      <el-table-column
        v-if="['ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="advertisementName"
        label="广告名称"
        width="300">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        prop="creativeId"
        label="创意ID">
      </el-table-column>
      <el-table-column
        v-if="['CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="placeType"
        label="广告位类型">
      </el-table-column>
      <el-table-column
        v-if="['GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        width="120"
        prop="cvType"
        label="转化类型">
      </el-table-column>
      <el-table-column
        v-if="['ACCOUNT'].includes(this.values)"
        prop="reportDate"

        label="按天维度查询时返回">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="uuid"
        width="180"
        label="账户id">
      </el-table-column>
      <el-table-column
        sortable
        prop="nameid"

        label="名称">
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        prop="campaignId"

        label="计划id">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"
        prop="balance"

        label="现金余额">
      </el-table-column>
      <el-table-column
        sortable
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        label="撞线警告">
        <template slot-scope="scope">
          <el-tag type="danger" v-if="scope.row.flag">警告警告 </el-tag>
          <el-tag type="success" v-else-if="!scope.row.flag">平安 </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        sortable

        prop="showCount"
        label="曝光量"
      >
      </el-table-column>
      <el-table-column
        sortable

        prop="clickCount"
        label="点击量">
      </el-table-column>
      <el-table-column
        prop="CTR"

        label="点击均价">
      </el-table-column>
      <el-table-column
        sortable
        :formatter="rule"

        prop="spent"

        label="花费">
      </el-table-column>
      <el-table-column
        sortable

        prop="formsubmitCount"
        label="表单提交量">
      </el-table-column>
      <el-table-column
        sortable

        prop="but"
        label="表单成本"
      >
      </el-table-column>
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        prop="dailyBudget"
        :formatter="rule1"
        label="日限额">
      </el-table-column>
      <!--      <el-table-column-->
      <!--        prop="customPayCount"-->
      <!--        label="自定义付费数(按计费时间)">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="zdyff"-->
      <!--        label="自定义付费数成本">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="reactivation"-->
      <!--        label="自定义拉活数(按计费时间)">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="zdylh"-->
      <!--        label="自定义拉活数成本">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="customRetainCount"-->
      <!--        label="自定义次留">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        prop="zdycl"-->
      <!--        label="自定义次留成本">-->
      <!--      </el-table-column>-->
      <!--      <el-table-column-->
      <!--        sortable-->
      <!--        prop="CVR"-->
      <!--        :formatter="ChangeToPercentage"-->
      <!--        label="转化率">-->
      <!--      </el-table-column>-->
      <!--      sortable-->
      <!--      <el-table-column-->
      <!--        prop="CLR"-->
      <!--        :formatter="ChangeToPercentage"-->
      <!--        label="次留率">-->
      <!--      </el-table-column>-->
      <el-table-column
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        sortable
        fixed="right"
        label="计划状态"
        prop="pauseState"

      >
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.pauseState"
            :active-value="0"
            :inactive-value="1"
            active-color="#13ce66"
            inactive-color="#ff4949"
            @change="changeSwitch($event,scope.row,scope.$index)"
          >
          </el-switch>
        </template>
      </el-table-column>
      <el-table-column
        fixed="right"
        label="操作"
        v-if="['CAMPAIGN','GROUP','ADVERTISEMENT','CREATIVE'].includes(this.values)"
        width="100">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" v-if="flag" type="text" size="small">查看</el-button>
          <el-button @click="edit(scope.row)" v-if="dingshi" type="text" size="small">定时</el-button>
          <el-button @click="edit1(scope.row)"  v-if="xiane" type="text" size="small">限额</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-drawer
      title="时段成本"
      :visible.sync="table"
      direction="rtl"
      size="50%">
      <el-table :data="HourList"
                v-loading="loading"
      >
        <el-table-column property="reportTime" label="日期" width="150"></el-table-column>
        <el-table-column property="campaignName" label="计划名称" width="200"></el-table-column>
        <el-table-column property="nameid" label="名称"></el-table-column>
        <el-table-column property="spent" label="花费"></el-table-column>
        <el-table-column property="formsubmitCount" label="表单提交量" width="200"></el-table-column>
        <el-table-column property="chengben" label="成本" width="200"></el-table-column>
      </el-table>
    </el-drawer>
    <el-dialog title="修改开启时间" :visible.sync="dialog">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="长期投放" >
          <span class="demonstration">开启日期</span>
          <el-date-picker
            v-model="value3"
            type="date"
            align="right"
            value-format="yyyy-MM-dd"
            placeholder="选择日期">
          </el-date-picker>
        </el-tab-pane>
        <el-tab-pane  name="second" label="指定开始和结束日期">
          <el-date-picker
            v-model="value1"
            type="daterange"
            align="right"
            unlink-panels
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions"
            @change="chooseTimeRange">
          </el-date-picker>
        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="updateTime(form)">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="修改日限额" width="500px"  :visible.sync="dialog1">

      <el-tabs v-model="activeName" @tab-click="boo" type="border-card">
        <el-tab-pane name="first" label="不限" >
          <el-tag>不限制任何额度</el-tag>
        </el-tab-pane>
        <el-tab-pane  name="second" label="自定义">
          <el-input v-model="money" style="width: 30%" placeholder="请输入内容"></el-input><el-tag>元/天</el-tag>

        </el-tab-pane>

      </el-tabs>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog1 = false">取 消</el-button>
        <el-button type="primary" @click="updateEd(form)">确 定</el-button>
      </div>
    </el-dialog>
  </div>

</template>

<script>
import FileSaver from 'file-saver';
import XLSX from 'xlsx';
export default {


  data() {
    return {

      loading:false,
      isDisable:false,
      userUalue:'',
      options1: [
        {
          value: 'sl',
          label: '亿典',
          // children: [{
          //   value: 'tui',
          //   label: '推啊',
          // },
          // ]
        },{
        value:'tianqiao',
          label: '天桥'
        },{
          value:'jzdj',
          label: '九州短剧'
        },{
        value: 'mzdj',
          label: '漫征短剧',
        }

        ,{
          value: 'zhdj',
          label: '智汇短剧',
        }
      ],
      options: [{
        value: 'DAY',
        label: '按天汇总'
      }, {
        value: 'HOUR',
        label: '按小时汇总'
      }, {
        value: 'SUMMARY',
        label: '汇总'
      }
      ],
      value: '',
      level: [{
        value: 'ACCOUNT',
        label: '账户层级'
      }, {
        value: 'CAMPAIGN',
        label: '计划层级'
      }, {
        value: 'GROUP',
        label: '广告组层级'
      },
        {
          value: 'ADVERTISEMENT',
          label: '广告层级'
        },
        {
          value: 'CREATIVE',
          label: '创意层级'
        }],
      zhdjtoken:['39b1b901c1726a4590dadce768a83a4ee3dae971a315bd3cd78bcaca94a118bb'],
      zhdj:[

          'fa3079e9ed4c27043e12',

          'e1c312e11718a902cac0',

          'a8890ea66e63dc7932fa',

          'aa9ae089554487a3f99a',

          'ff22b392de0f9759baba',

          '921033a19aa60a60250a',

          '61476ae3478d37332771',

          'a3d891f66e11ca24e122',

          '808494f9e2a79776fd7a',

          'b9c9585b0e4b29e5343e',

          '8a05757f01cb1462f810',

          '8dcc5640b7bde92ce9d4',

          'eb955bab7d833c9daf3e',

          'c307c7badfdeb837d54d',

          'beae76de2bcea3deb102',


      ],
  mzdjtoken:['35d21a96e09f396a16ec2d40b7ad60b7ba0ed2f893e97e97574215092721ea2b'],
      mzdj:[



                 '4bfcfb4a62b0cec2b453',

                 'e469b66f2c062b6c56a6',

                 '7b150f882a87dd16f868',

                 'df24796bbea0886addda',

                 '2732f00a502b0537b483',

                 '477be42137a9b4cf54dc',

                 'bfae832d0d332449c4e8',

                 'd338d78e8732248176c9',

                 'eab24b9f0cc1c360fe30',

                 '1c6326971e47433a13fb',

                 '010efa74304b8fecbbe5',

                 'c4b42b026a1d546657c9',

                 'ed7bbc471bb462949106',

                 '05263d4f8ffab1acbbd9',

                 'ef0b8db79be84e86c173',

                 '9b095303c167cb8d671b',

                 '3848546b1acd12783e90',

                 'eed6bb27d1538dc10ae9',

                 '70a57a29df4c84ffd9b4',

                 '31643ac1b016979fcbbf',

                 '2a697b294a7d03681a0b',

                 '1691d2f08e6a81cb7f52',

                 '246a7c41ed92fe29aad4',

                 'fbd77e3342f30cc2c69a',

                 '094516e6cabd2f2ddcb8',

      ],
      tianqiao:[

        '1ef9e6f04356af315438',
        '58cde9c91ff5da0e5fc2',
        '26478e8b3035f1b722de',
        '49ff4895715fc9873209',
        '6a288dbe0503f105a7d8',
        'ea278fb27959acc3da08',
        'e0d4daefe4e43d69f63c',
        '4e332770530bf41fce2e',
        'b3f778e4a4425a33be45',
        '50bb831d2794c559d8b0',
        'e56815c0314a773cc59a',
        '04339570940c52e80e12',
        '8c510930be4d84f26614',
        'b18d286f2a30a71bba92',
        '92ef9176449af152fec2',
        'a4ba66ac9567d6529a0e',
        '1e9992a03409f17abaf3',
        '101709a1d6f44b32fbcc',
        'df18460d1eee77a3eb32',
        'eae3e8ef0f76fe739642',
        '910155ded1406d2a987c',
        'cdeb652328004592c987',
        '3ddeacf097e5ebe621bd',
        'bfbab103bd0ff49ba1de',
        'cc214c3711e26ad5cf3d',
        '7f9e591cdac9046a3ed3',
        '58fb9232120c4c2c00f0',
        '81a57f0e106b9d9bfaad',
        '1df0870bd3302152b5a6',
        '1f4b38ca16471bb43bd1',
        '0d63829f56291d110114',
        'a6acfa13694ba07882ca',
        'bd2c1437fd152b48d917',
        'f2d2781df832cecbd752',
        'f5b7584871a2cd37d110',
        'b4eaa81942bd1b2c44f4',
        '1d24a82513c189369e6f',
        '9dd78e9899f4f2e85241',
        'bfd514d11e3d07729254',
        '4c26e9a074e7353a2f36',
        'd622641d85814117c42a',
        'e387e667f68eb0a8963f',
        'fba9c828dc25786f3817',
        '70f37bd5c1947866bd86',
        '0f8b1e2b1467457bab45',
        '87e8625dae3a974e5fb0',
        '50ba255c8ef02ce09f8c',
        'a4d119cc5881368b0d51',
        'cc2010f02a487af2dd86',
        'fe9ecf3f6ce56b089c58',
        '99d1ed45aa90b5c22e15',
        '88eaed05da5bb9529058',
        'de9b7a1504383f751b3f',
        '318d58e7b0c4f1b2a88f',
        '895412c2d7c072bc4a80',
        'dd638f711de5ef9e0b70',
        'fa1bd8772f7e07e8a116',
        '2548c6f5e4491a7aec79',
        'ea1afc3e96c8a6ee7184',
        '219d67cc263d121a4eb9',

      ],
      tianqiaotoken:['95543ea93800fa514a9110abba375e098441033cf66d9e54ab6d9ed00af1f19e'],
      xiaowei:['d82e720799bfc370b748690971b9274070406f7a0951bf6f96401a6ac670d417'],
      // tui:[
      //   'e65a144156fc511a2aa2',
      //   '578df0a62bf77b60b26a',
      //   '93f7e451e30f5100492a',
      //   'aa773c0c07cb296f067e',
      //   'bea60fbad3a56c944b3e',
      //   '5eb3df4ea2014e913a9c',
      //   '6914c879ada2d34bd100',
      //   '5509f01b307d3de6d551',
      //   'c143b70fb0d74b0a849c',
      //   '061d5d8ffc38dbb6a7be',
      //   '9e9b8d00095b12047d96',
      //   '62901e674d3e30f0e002',
      //   '5ba4579d4a2abfcd89c9',
      //   '0dbadedfe5657a3c2978',
      //   'e86736fb7c6cd556372f',
      //   '19742aa79ecf4d394839',
      //   '5cbe8d3cfb38c5924f35',
      //   '72333d3a49472fd9ab39',
      //   'c543137523571bb43df1',
      //   '8e5353dc2a2906077b24',
      //   '388e4a2405dd39c280e7',
      //   '300c527b515287342db6',
      //   '7026d51884e9cce5fc02',
      //   'dcdbac37a7f5e416a968',
      //   '64526e7d211dd86b6f09',
      //   '54e535c395d67682e2e6',
      //   '8c565b1c9e393195fc3b',
      //   '3d5e325face648dd7157',
      //   'c88a4e38c404bbed9246',
      //   'e36750c1fff00faf25af',
      //   'e6363efa09ebe3232c33',
      //   '58d21cb7d8a0fc1890f3',
      //   '75757b1a1c563f84dd7a',
      //   'e4c3099ce2b78dccf5e8',
      //   '3b1a0cf99ed5f0d0f1fd',
      //   'b628c52cf17836779142',
      //   '2de554a66d357904a118',
      //   '0f8a85f7891b0ce64b86',
      //   '973e1eeb97f3324c2933',
      //   'c4a2d1913629abbb1cc2',
      //   '7f8a622ebb592f47c0b4',
      //   '747ff1c26a22903e4f65',
      //   'a19e605f74ba7675f568',
      //   '035342564067da1b3766',
      //   '192b6a6198dbddcc9262',
      //   '8c51da348be94145d6cd',
      //   'e4c4948b7599a632d945',
      //   '094cc9aa1e96dd28fcb0',
      //   '03821ad1c5a09701ce7e',
      //   '2883976c5ee9bbc3df37',
      //   'ff373ae4fe25a25c98c2',
      //   '51761ef8a824adb8eb31',
      //   'cf2a62a5a95293100868',
      //   '6135be782473a284ebcf',
      //   '4a6917b9aed3fe63e71b',
      //   'fa30e6b9bdfcb9a68467',
      //   '8ecb81992647d04a5cf0',
      //   '062a80788da8f47a0d55',
      //   'ac5eec96191d22c5dcfc',
      //   'b8796f9284504dd87566',
      //   '79b53d58250197f7e5f9',
      //   '211ec69d1fea6670f58a',
      //   'e3f62579815396910d21',
      //   '55d50c051db9cd84465a',
      //   '05ad7c3c2f36a0b18ce7',
      //   'ed8826a096d1bd844784',
      //   '100ec567969d4c7a3941',
      //   '01bd4ca671798b557924',
      //   'bb92b3e170ab60eb85af',
      //   '8274b77c2ae5ee6f71d5',
      //   '1e2d05194749d4e0805b',
      //   '615e35cf8564de8f7ddc',
      //   'c24fb36984c4b7329b62',
      //   '1e02936cf6ced91d11de',
      //   '263e28523d287b411025',
      //   '9e040d3e1dd9639b36e4',
      //   '8f11ee1e0b73ff69d965',
      //   '86a376988ef7f0d7c404',
      //   '520ce62b8fd96a27c80e',
      //   'cf81fe15d48ea341b0cf',
      //   'bb00683b0e690196c145',
      //   '770f0ac66089ce625053',
      //   '18ae414269508016ead6',
      //   'a83e1c926f7b574227e5',
      //   '5c3bf99842172544201c',
      //   '0821eb7ec9357cfd47e6',
      //   'b1ba65e50f234070481d',
      //   'c867644b4eba71c83af6',
      //   '22ad07372e289edc0def',
      //   'c639fd2034818cb64d0d',
      //
      // ],
      tui1:[
        '9c8ee229ed2baeaabd55',
        '954c0382461a15fe4f39',
        'a05f9d3bb6e1e4a248cf',
        '90cf7e8a583559bfbea4',
        '01cfcd7ee6ab72522111',
        'f4b41ecca1a58aa80aeb',
        'd2a7fe2c7c382a3b468f',
        'f264e007152c262973f3',
        '6f8693519f70796b7233',
        '1982b0c46fc509c9e962',
        '634c93ba72c8afe80e05',
        '33922e85f71fc27ee45c',
        'be4ae03b2966a562b221',
        '267e390b96aa06989add',
        '3c9af1836f2525c1746a',
        '24514d0a72788f9a96fb',
        '69ac8f03e4f4a04e7922',
        '4edde9512a077a606e42',
        'c98033a9731e23c1e6cd',
        '556d640a4d23e885cf41',
        '72cf5691bf2a2fac568e',
        'd2319a751bee065ac26b',
        '14fe4ee012af92024c14',
        '6c800d81cd623418d0b0',
        '61a4ea8ac98cda477a7f',
        '300fdc381d3a9288830d',
        'dd767b76bb7423cb86c7',
        'acf29920896baa62ef1a',
        'cde72769b9827986d80e',
        '8007cadfc99116fcfd62',
        '55565e818f1249fa7829',
        '0ff127624c09ba66a1ec',
        '67ca5ff93d93757b3a9d',
        '603a1fa6ac74929832a8',
        'ddfe0c869002f9c12b75',
        '243f4d6b6f18c7850424',
        'b538166c6140d683dde0',
        '37fe4a9d294608ee45a6',
        '5052e65ebe15e387711b',
        '4ce5c34022d84eb62eee',
        '545816217914ec7fcb0a',
        '337f769bd0d2e1953e89',
        '4e03431ec7601304daf4',
        '66abdcaf270ae5136f2b',
        '5d4c82674aa65179a4d6',
        '894d1406181fc855fbac',
        'e655c5c9099a53d24e8d',
        'd9cea47085349a0f03ad',
        '8b8f46b85c10d533f819',
        '37738782a6d425abd187',
        '6477a9e649e4a7454ff1',
        '16f9f11f8a414a939476',
        'cec3ae8c697d33c24a65',
        'e0d613c718523ce6b80a',
        'e1c03a1178f76efe7a3c',
        'f9a67bb0a15316a8c21e',
        'dd470c57112e54d3d353',
        'a519d6422f744c98d192',
        '230166e7cfdbad3cf86e',
        '886449d939c2ed2168aa',

      ],
      tui:[ 'e65a144156fc511a2aa2',

        '578df0a62bf77b60b26a',

        '93f7e451e30f5100492a',

        'aa773c0c07cb296f067e',

        'bea60fbad3a56c944b3e',

        '5eb3df4ea2014e913a9c',

        '6914c879ada2d34bd100',

        '5509f01b307d3de6d551',

        'c143b70fb0d74b0a849c',

        '061d5d8ffc38dbb6a7be',

        '9e9b8d00095b12047d96',

        '62901e674d3e30f0e002',

        '5ba4579d4a2abfcd89c9',

        '0dbadedfe5657a3c2978',

        'e86736fb7c6cd556372f',

        '19742aa79ecf4d394839',

        '5cbe8d3cfb38c5924f35',

        '72333d3a49472fd9ab39',

        'c543137523571bb43df1',

        '8e5353dc2a2906077b24',

        '388e4a2405dd39c280e7',

        '300c527b515287342db6',

        '7026d51884e9cce5fc02',

        'dcdbac37a7f5e416a968',

        '64526e7d211dd86b6f09',

        '54e535c395d67682e2e6',

        '8c565b1c9e393195fc3b',

        '3d5e325face648dd7157',

        'c88a4e38c404bbed9246',

        'e36750c1fff00faf25af',

        'e6363efa09ebe3232c33',

        '58d21cb7d8a0fc1890f3',

        '75757b1a1c563f84dd7a',

        'e4c3099ce2b78dccf5e8',

        '3b1a0cf99ed5f0d0f1fd',

        'b628c52cf17836779142',

        '2de554a66d357904a118',

        '0f8a85f7891b0ce64b86',

        '973e1eeb97f3324c2933',

        'c4a2d1913629abbb1cc2',

        '7f8a622ebb592f47c0b4',

        '747ff1c26a22903e4f65',

        'a19e605f74ba7675f568',

        '035342564067da1b3766',

        '192b6a6198dbddcc9262',

        '8c51da348be94145d6cd',

        'e4c4948b7599a632d945',

        '094cc9aa1e96dd28fcb0',

        '03821ad1c5a09701ce7e',

        '2883976c5ee9bbc3df37',

        'ff373ae4fe25a25c98c2',

        '51761ef8a824adb8eb31',

        'cf2a62a5a95293100868',

        '6135be782473a284ebcf',

        '4a6917b9aed3fe63e71b',

        'fa30e6b9bdfcb9a68467',

        '8ecb81992647d04a5cf0',

        '062a80788da8f47a0d55',

        'ac5eec96191d22c5dcfc',

        'b8796f9284504dd87566',

        '79b53d58250197f7e5f9',

        '211ec69d1fea6670f58a',

        'e3f62579815396910d21',

        '55d50c051db9cd84465a',

        '05ad7c3c2f36a0b18ce7',

        'ed8826a096d1bd844784',

        '100ec567969d4c7a3941',

        '01bd4ca671798b557924',

        'bb92b3e170ab60eb85af',

        '8274b77c2ae5ee6f71d5',

        '1e2d05194749d4e0805b',

        '615e35cf8564de8f7ddc',

        'c24fb36984c4b7329b62',

        '1e02936cf6ced91d11de',

        '263e28523d287b411025',

        '9e040d3e1dd9639b36e4',

        '8f11ee1e0b73ff69d965',

        '86a376988ef7f0d7c404',

        '520ce62b8fd96a27c80e',

        'cf81fe15d48ea341b0cf',

        'bb00683b0e690196c145',

        '770f0ac66089ce625053',

        '18ae414269508016ead6',

        'a83e1c926f7b574227e5',

        '5c3bf99842172544201c',

        '0821eb7ec9357cfd47e6',

        'b1ba65e50f234070481d',

        'c867644b4eba71c83af6',

        '22ad07372e289edc0def',

        'c639fd2034818cb64d0d',

        'd7737b6b202473bce9a7',

        '872219c6919330233326',

        '8c324d1c44be706fd25c',

        '93fb9f0a90796e1e186f',

        '70aeece0896968198469',
      ],

      jzdj:[
                '71e612babfd7e50bd723',

                '4f8e23b44f9439534606',

                'f5050ee93acc325cfeaa',

                '94a4c042a9f939ce0485',

                '270b5e2aa155d4e26207',

                '30f3c8daf399437b9ab4',

                '39ce95cfc63594f50689',

                '7596211570a26fd2e200',

                '97356c93f0729c68d29b',

                '0a76a765862084b1cd08',


                '08c3070d3788c67b6eb1',

                '094ac7c7d31ba6767a25',

                'f91418dd999981d8912b',

                '3fad5bf561614a6f726e',

                '3fc2ac1176f1974830dc',

                'a69742b54861f1f85960',

                '3f01691eafa935b0642f',

                'fb363b28b6c0f90423b6',

                '91fe407f6509c29ccc07',

                'b7460c520479d8edb88b',

      ],
      jzdjtoken:['c6ac8470f658fc8a192481af9f4462c55498e191e4aa529eb7fcdcfbb8a059d4'],

      values: '',
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      money:200,
      value3:'',
      time:'',
      value1: '',
      value2: '',
      datas:[],
      datadata:[],
      temp:[],
      temp1:[],
      temp2:[],
      startDate:'20220701',
      endDate:'20220710',
      namedata:[],
      datanums:[
        {
          nuMshowCount:0,
          nuMclickCount:0,
          nuMspent:0,
          nuMformsubmitCount:0,
          nuMdisGeneralBalance:0,
          nuMbalance:0,
          nuMcustomPayCount:0,
          nuMreactivation:0,
          nuMcustomRetainCount:0
        }
      ],
      ctrJson:[{
        flag:false,
        nameid:'',
        CTR:0,
        CVR:0,
        CLR:0,
        but:0,
        zdycl:0,
        zdyff:0,
        zdylh:0

      }],
      playCode:[],
      TempData:[],
      table:false,
      dialog: false,
      dialog1:false,
      HourList:[],
      Hourmap:new Map,
      sums:0,
      flag:true,
      form:[],
      group:{},
      kaiguan:0,
      activeName: 'first',
      grouplist:{},
      dingshi:true,
      xiane:true,
      sks:''


    }
  },

  methods:{
//面板状态
    boo(tab) {
      if(tab.name==="first"){
        this.kaiguan=0
      }else if (tab.name==="second"){
        this.kaiguan=1
      }

    },

    //限额方法提交
    updateEd(){
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }else {
        if(this.kaiguan===0){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:-1,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)

        }else if (this.kaiguan===1){
          let t1={
            id:this.grouplist.campaignId,
            dailyBudget:this.money*100000,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostMoeny(t1)
        }
      }


      this.dialog1=false

    },

    //投放时间方法提交
    updateTime(){
      let endtime='2038-01-19'
      if (this.grouplist.userId==="d58d2e06d91f1fcc1734"){
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:'6871c87dc96f817bb95b0790a54de176e582e5156d0f69485f1f4b1733e018f7',
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }
      else {
        if(this.kaiguan===0){
          //发送
          console.log(this.value3)
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value3,
            endDate:endtime,
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }else if (this.kaiguan===1){
          let pams={
            ids:this.grouplist.groudId,
            startDate:this.value2.at(0),
            endDate:this.value2.at(1),
            token:this.sks,
            adid:this.grouplist.userId
          }
          this.PostGroup(pams)
        }
      }

      this.dialog = false
    },

    //限额
    edit1(row){
      console.log(row)
      this.grouplist={}
      this.grouplist={
        campaignId:row.campaignId,
        userId:row.userId,
      }
      this.dialog1=true
    },

    //投放日期
    edit(row){
      this.grouplist={}
      this.grouplist={
        userId:row.userId,
        groudId:row.groupId
      }

      this.dialog=true
      return row
    },

    //显示表单
    handleClick(row){
      this.HourList=[],
        this.TempData=[],
        this.TempData.push(row)
      for (let key=1;key<=this.Hourmap.size;key++){
        // console.log(this.Hourmap.get(key))
        for (let keys=0;keys<this.Hourmap.get(key).length;keys++){
          // console.log(this.TempData.campaignId)
          if(this.Hourmap.get(key)[keys].campaignId===this.TempData[0].campaignId){

            this.HourList.push(this.Hourmap.get(key)[keys])
          }
        }
      }
      let str=[{
        nameid:'',
        balance:'',
        chengben:''
      }];
      str[0].nameid=this.TempData[0].nameid;
      str[0].balance=this.TempData[0].balance;
      for(let i in this.HourList){
        console.log(this.HourList[i].spent)
        console.log(this.HourList[i].formsubmitCount)
        if (this.HourList[i].formsubmitCount===0){
          str[0].chengben=this.HourList[i].spent
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }else {
          str[0].chengben=this.HourList[i].spent/this.HourList[i].formsubmitCount
          str[0].chengben = parseFloat(str[0].chengben).toFixed(6);
          let tempVal3 = parseFloat( str[0].chengben).toFixed(5);
          str[0].chengben = tempVal3.substring(0,tempVal3.length - 1);
        }


        this.HourList[i]=this.hb(this.HourList[i],str[0])
      }
      this.table=true



      // get发送请求获取本条的投放时间
      // 生成折线图


    },

    //切换开关
    changeSwitch(value,row,index){
      let time1 = parseInt(new Date().getTime()) + '';
      let nonce = Math.round(Math.random() * 100000000000)
      const { id,pauseState,userId} = row
      let params = {
        userId:userId,
        id:id,
        pauseState: pauseState ? '1' : '0'  // 三元运算符  类似于if else
      };

      this.$axios.post('api/openapi/v1/ad/campaign/pause/toggle?access_token='+this.sks+'&timestamp='+
        time1+'&nonce='+nonce+'&advertiser_id='+params.userId,{
        ids:params.id,
        startAndStop:params.pauseState
      }).then(async res=> {
        if (res.data.code === 0) {
          this.$message.success(`${pauseState ? '已停用' : '已启用'}`)
        }
      })

    },

    //限额显示的规则
    rule1(row,column){
      if (row[column.property]===-1){
        return '未限额'
      }else {
        var percent = row[column.property]/100000
        return percent
      }
    },

    //总汇规则
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      if (this.values==="ACCOUNT"){ //账户层级
        let a=0;
        console.log(param.data)
        console.log(param.data.length)
        columns.forEach((column, index) => {

          if (index === 0) {
            sums[index] = '总汇';
            return;
          }

          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if(index===5){

            sums[index] = sums[index]/param.data.length;
            sums[index]= sums[index].toFixed(2);
            sums[index]=sums[index]
            return;
          }
          if (index === 10) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 12) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 14) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {

            return;

          }

          if (index === 16) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }

        });
        return sums;
      }else if(this.values==="CAMPAIGN"){ //计划层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }


          if (index === 8) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index]=sums[index].toFixed(2);
            sums[index]=sums[index]/10
            sums[index]= sums[index]+'%'
            sums[index]=sums[index]
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }     if (index === 12) {

            return;

          }
          if (index === 14) {
            sums[index] = sums[index-5]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }

          if (index === 16) {
            sums[index] = sums[index-7]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 18) {
            sums[index] = sums[index-9]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 19) {

            return;

          }if (index === 20) {

            return;

          }

          if (index === 21) {

            return;

          }


          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }else if(this.values==="GROUP"){ //广告组层级
        columns.forEach((column, index) => {
          if (index === 0) {
            sums[index] = '总汇';
            return;
          }  if (index === 9) {
            sums[index] = sums[index-2]/sums[index-1];
            sums[index] =  sums[index].toFixed(2) ;
            return;

          }
          if (index === 6) {
            sums[index] = sums[index-1]/sums[index-2];
            sums[index]=sums[index]*100
            sums[index]=sums[index].toFixed(2);
            sums[index]= sums[index]+'%'
            return;

          }
          if (index === 11) {
            sums[index] = sums[index-4]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 13) {
            sums[index] = sums[index-6]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 15) {
            sums[index] = sums[index-8]/sums[index-1];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]
            return;

          }
          if (index === 16) {
            sums[index] = sums[index-8]/sums[index-11];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }
          if (index === 17) {
            sums[index] = sums[index-5]/sums[index-9];
            sums[index]=sums[index].toFixed(4);
            sums[index]=sums[index]*100+'%'
            return;

          }



          const values = data.map(item => Number(item[column.property]));
          if (!values.every(value => isNaN(value)) ) {
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return prev + curr;
              } else {
                return prev;
              }
            }, 0);

            sums[index] = sums[index].toFixed(2) + "";
          } else {
            sums[index] = '';
          }
        });
        return sums;
      }
    },
    //导出表单api
    exportExcel () {
      /* generate workbook object from table */
      var xlsxParam = { raw: false } // 导出的内容只做解析，不进行格式转换
      var wb = XLSX.utils.table_to_book(document.querySelector('#exportTab'), xlsxParam)

      var wbout = XLSX.write(wb, { bookType: 'xlsx', bookSST: true, type: 'array' })
      try {
        FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), '数据导出.xlsx')
      } catch (e) {
        if (typeof console !== 'undefined') {
          console.log(e, wbout)
        }
      }
      return wbout
    },

    //规则
    rule(row,column){
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property]).toFixed(2)
        return percent
      }
    },

    //查询时间选择器函数
    ChangeToPercentage: function(row, column) {
      if (row[column.property]===undefined){
        return null
      }else {
        var percent = (row[column.property] * 100).toFixed(2) + '%'
        return percent
      }

    },

    // 获取时间戳，获取时间选择器时间
    chooseTimeRange(value1){
      this.time = parseInt(new Date().getTime()) + '';
      console.log(this.time)
      this.value2=value1;

    },

    //渲染data、数据处理通用方法
    windowList(){
      //渲染页
      this.temp=JSON.parse(JSON.stringify(this.datadata))
      this.temp1=JSON.parse(JSON.stringify(this.namedata))
      this.temp3=JSON.parse(JSON.stringify(this.playCode))
      for (let key = 0; key < this.temp.length; key++) {
        this.ctrJson[0].flag=false;
        let t=0;
        this.ctrJson[0].nameid=this.temp1[key].name
        this.temp1[key].balance=this.temp1[key].balance+this.temp1[key].disGeneralBalance
        this.temp1[key].balance = this.temp1[key].balance / 100000

        this.temp2[key] = this.hb(this.temp1[key], this.temp[key])
        if (this.temp2[key].spent===0){
          this.ctrJson[0].but=0
        }else if (this.temp2[key].formsubmitCount===0){
          this.ctrJson[0].but=this.temp2[key].spent
        }else {
          this.ctrJson[0].but = this.temp2[key].spent / this.temp2[key].formsubmitCount
          this.ctrJson[0].but = parseFloat(this.ctrJson[0].but).toFixed(6);
          let tempVal3 = parseFloat(this.ctrJson[0].but).toFixed(5);
          this.ctrJson[0].but = tempVal3.substring(0, tempVal3.length - 1);
        }
        this.ctrJson[0].CTR=this.temp2[key].spent/this.temp2[key].clickCount
        this.ctrJson[0].CTR = parseFloat(this.ctrJson[0].CTR).toFixed(6);
        let tempVal = parseFloat(this.ctrJson[0].CTR).toFixed(5);
        this.ctrJson[0].CTR = tempVal.substring(0, tempVal.length - 1);

        this.ctrJson[0].CVR = this.temp2[key].formsubmitCount / this.temp2[key].clickCount
        this.ctrJson[0].CVR = parseFloat(this.ctrJson[0].CVR).toFixed(6);
        let tempVal1 = parseFloat(this.ctrJson[0].CVR).toFixed(5);
        this.ctrJson[0].CVR = tempVal1.substring(0, tempVal.length - 1);
        this.ctrJson[0].CLR = this.temp2[key].customRetainCount / this.temp2[key].formsubmitCount
        this.ctrJson[0].CLR = parseFloat(this.ctrJson[0].CLR).toFixed(6);
        let tempVal2 = parseFloat(this.ctrJson[0].CLR).toFixed(5);
        this.ctrJson[0].CLR = tempVal2.substring(0, tempVal.length - 1);

        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdycl=0
        }else if (this.temp2[key].customRetainCount===0){
          this.ctrJson[0].zdycl=this.temp2[key].spent
        }else {

          this.ctrJson[0].zdycl=this.temp2[key].spent/this.temp2[key].customRetainCount;
          this.ctrJson[0].zdycl=parseFloat(this.ctrJson[0].zdycl).toFixed(6)
          let tempVal4=parseFloat(this.ctrJson[0].zdycl).toFixed(5)
          this.ctrJson[0].zdycl = tempVal4.substring(0, tempVal4.length - 1);
        }




        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdyff=0
        }else if (this.temp2[key].customPayCount===0){
          this.ctrJson[0].zdyff=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdyff=this.temp2[key].spent/this.temp2[key].customPayCount;
          this.ctrJson[0].zdyff=parseFloat(this.ctrJson[0].zdyff).toFixed(6)
          let tempVal5=parseFloat(this.ctrJson[0].zdyff).toFixed(5)
          this.ctrJson[0].zdyff = tempVal5.substring(0, tempVal5.length - 1);
        }


        if (this.temp2[key].spent===0){
          this.ctrJson[0].zdylh=0
        }else if (this.temp2[key].reactivation===0){
          this.ctrJson[0].zdylh=this.temp2[key].spent
        }else {
          this.ctrJson[0].zdylh=this.temp2[key].spent/this.temp2[key].reactivation;
          this.ctrJson[0].zdylh=parseFloat(this.ctrJson[0].zdylh).toFixed(6)
          let tempVal6=parseFloat(this.ctrJson[0].zdylh).toFixed(5)
          this.ctrJson[0].zdylh = tempVal6.substring(0, tempVal6.length - 1);
        }




        //  限额提醒代码
        if(this.temp3[key].dailyBudget!=-1){
          t=this.temp3[key].dailyBudget/100000
          t=t*0.8
          if (this.temp2[key].spent>=t){
            this.ctrJson[0].flag=true;
          }
        }
        this.temp2[key] = this.hb(this.temp2[key], this.ctrJson[0])
        this.temp2[key]=this.hb(this.temp2[key],this.temp3[key])
      }
      this.temp2=JSON.parse(JSON.stringify(this.temp2))
      this.datas=this.temp2
      console.log(this.temp2)
      this.isDisable = false
      if (this.value==="DAY"){
        this.flag=false;
        if (this.values==="GROUP"){
          this.dingshi=true;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=true;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }else if (this.value==="HOUR"){
        this.flag=true;
        if (this.values==="GROUP"){
          this.dingshi=false;
          this.xiane=false;
        }else if(this.values==="CAMPAIGN" ){
          this.dingshi=false;
          this.xiane=false;
        }else if (this.values==="ACCOUNT"){
          this.dingshi=false;
          this.xiane=false
        }
      }

      this.loading=false
    },

    //查询广告效果api
    async PostListQuery(parms){

      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/adstatement/summary/query?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a], {
        startDate: parms.startDate,
        endDate: parms.endDate,
        pageIndex: "1",
        pageSize: "100",
        summaryType: parms.summaryType,
        level: parms.level
      }).then(async resp => {
        if (resp.data.code!==60806){  if (resp.data.data.items !=null){
          if (this.value==="HOUR"){
            // 存取小时的数据[]
            this.sums=this.sums+1;
            console.log(resp.data.data.items)
            this.Hourmap.set(this.sums,resp.data.data.items)
            let arr=[];
            let map=new Map;
            for(let key in resp.data.data.items){
              var time=new Date(resp.data.data.items[key].reportTime)
              let reTimeHour=time.getHours(); //获取返回整点时间
              var date=new Date()
              let hour=date.getHours();  // 获取当前时间
              if (hour===reTimeHour){
                arr.push(key)   //定位现在整时位置
                map.set(key,resp.data.data.items[key])// 记录下现在的数据
              }
            }
            for (let keys in arr){

              this.datadata.push(map.get(arr[keys]))
              let obj={
                ids:resp.data.data.items[arr[keys]].campaignId,
                lengths:arr.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:arr.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }else{
            console.log(resp.data)

            for (let b=0;b<resp.data.data.items.length;b++){

              this.datadata.push(resp.data.data.items[b])
              let obj={
                ids:resp.data.data.items[b].campaignId,
                lengths:resp.data.data.items.length
              }
              let pams=Object.assign(obj,parms)
              await this.PostListplayCode(pams)
            }
            let obj1={
              lengths:resp.data.data.items.length
            }
            parms=Object.assign(obj1,parms)
            await this.GetListUserId(parms);

          }

        }}

      })

    },

    //修改限额api
    async PostGroup(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/group/batchEditDate?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "ids":pams.ids,
          "startDate":pams.startDate,
          "endDate":pams.endDate
        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改投放日期失败，请检查日期是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改投放日期成功',
            type: 'success'
          });
        }

      })


    },

    //修改投放日期api
    async PostMoeny(pams){
      console.log(pams)
      let time = parseInt(new Date().getTime()) + '';
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/editDailyBudget?access_token='+ pams.token + '&timestamp=' + time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid,
        {
          "id":pams.id,
          "dailyBudget":pams.dailyBudget,

        }).then(resp=>{

        console.log(resp.data)
        if (resp.data.code===70111){
          this.$notify.error({
            title: '错误',
            message: '修改限额失败，请检测限额是否错误'
          });
        }else {
          this.$notify({
            title: '成功',
            message: '修改限额成功',
            type: 'success'
          });
          this.getDataList()
        }

      })


    },
    //查询账号信息api
    async GetListUserId(parms){
      let nonce = Math.round(Math.random() * 100000000000)
      await this.$axios.get('api/openapi/v1/account/fetch?access_token=' + parms.token + '&timestamp=' + this.time + '&nonce=' + nonce + '&advertiser_id=' + parms.adid[parms.a])
        .then(async res => {
            if (res.data.message == '请求成功') {
              this.$message.success("正在查询第"+parms.a+"条")
              //测试
              if (this.value==="HOUR"){
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }else{
                for (let e=0;e<parms.lengths;e++){
                  this.namedata.push(res.data.data)
                }
              }
            } else {
            }
          }

        )
    },
    // 查询计划状态api
    async PostListplayCode(pams){
      let nonce2 = Math.round(Math.random() * 100000000000)
      await this.$axios.post('api/openapi/v1/ad/campaign/pageInfo?access_token='+ pams.token + '&timestamp=' + this.time + '&nonce=' + nonce2 + '&advertiser_id=' + pams.adid[pams.a],
        {
          "ids":pams.ids,
        }).then(resps=>{
        if (resps.data.data.list===undefined){
          this.playCode.push({pauseState:1})
        }else {
          console.log(resps.data.data.list[0])
          this.playCode.push(resps.data.data.list[0])
        }
      })
    },
    hb(jsonbject1, jsonbject2) {
      var resultJsonObject = {};
      for (var attr in jsonbject1) {
        resultJsonObject[attr] = jsonbject1[attr];
      }
      for (var attr in jsonbject2) {
        resultJsonObject[attr] = jsonbject2[attr];
      }
      return resultJsonObject;
    },

    getDataList() {

      this.time = parseInt(new Date().getTime()) + '';
      this.datanums[0].nuMshowCount=0
      this.datanums[0].nuMclickCount=0
      this.datanums[0].nuMspent=0
      this.datanums[0].nuMformsubmitCount=0
      this.datanums[0].nuMbalance=0
      this.datanums[0].nuMdisGeneralBalance=0
      this.datanums[0].nuMcustomPayCount=0
      this.datanums[0].nuMreactivation=0
      this.datanums[0].nuMcustomRetainCount=0
      this.datas=null
      this.datadata=[]
      this.namedata=[]
      this.playCode=[]
      this.temp2=[]
      this.temp1=[]
      this.temp=[]
      console.log(this.userUalue[0])
      console.log(this.userUalue[1])
      if(this.value!=="" && this.value1!==""){
        this.isDisable = true
        this.loading=true
        this.TimeChangeto1();
      }else {
        alert("请选择数据")
      }

    },

    async TimeChangeto1 () {
      console.log("看到我了")
      console.log(this.userUalue[1])
      if (this.userUalue[0]==="sl"){
        this.sks=this.xiaowei[0]
        this.sums=0;
        for (let a = 0; a < this.tui.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tui
          }
          await this.PostListQuery(parms)
        }


        this.windowList()
      }

      else       if (this.userUalue[0]==="tianqiao"){
        this.sks=this.tianqiaotoken[0]
        this.sums=0;
        for (let a = 0; a < this.tianqiao.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.tianqiao
          }
          await this.PostListQuery(parms)
        }


        this.windowList()
      }
      else       if (this.userUalue[0]==="mzdj"){
        this.sks=this.mzdjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.mzdj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.mzdj
          }
          await this.PostListQuery(parms)
        }


        this.windowList()
      }
      else       if (this.userUalue[0]==="zhdj"){
        this.sks=this.zhdjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.zhdj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.zhdj
          }
          await this.PostListQuery(parms)
        }


        this.windowList()
      }

      else       if (this.userUalue[0]==="jzdj"){
        this.sks=this.jzdjtoken[0]
        this.sums=0;
        for (let a = 0; a < this.jzdj.length; a++) {
          let parms={
            a:a,
            startDate:this.value2.at(0),
            endDate: this.value2.at(1),
            summaryType: this.value,
            level: this.values,
            token:this.sks,
            adid:this.jzdj
          }
          await this.PostListQuery(parms)
        }


        this.windowList()
      }
    },


  },
  created () {  },
}
</script>

























// WEBPACK FOOTER //
// src/components/yidian.vue